import { isLive } from '@/function/begateway/rule.order';
import type { TypeAccessRule, TypeAccessRuleQuery } from '@/types/begateway/types.begateway.access';

export const byNewestRule = (a: TypeAccessRule, b: TypeAccessRule): number =>
    b.audit.createdAt.localeCompare(a.audit.createdAt) || b.id.localeCompare(a.id);

export const accessQueryParams = (query: TypeAccessRuleQuery): Record<string, string> => Object.fromEntries(
    Object.entries(query).filter(([key, value]) => typeof value === 'string' && value !== '' && (key === 'state' || value !== 'all')),
) as Record<string, string>;

const picks = <T extends string>(wanted: T | 'all' | undefined, actual: T): boolean => !wanted || wanted === 'all' || wanted === actual;

export function ruleMatchesQuery(rule: TypeAccessRule, query: TypeAccessRuleQuery, now = Date.now()): boolean {
    if (query.state === 'active' && !isLive(rule, now)) return false;
    if (query.route && rule.scope.route !== query.route) return false;
    if (query.endpointId && rule.scope.endpointId !== query.endpointId) return false;
    if (query.subjectValue && rule.subject.value !== query.subjectValue) return false;
    return picks(query.scopeKind, rule.scope.kind) && picks(query.action, rule.action) && picks(query.subjectType, rule.subject.type);
}

export default ruleMatchesQuery;
